import { Button } from '@heroui/react'
import { Download } from 'lucide-react'
import { useCallback, useState } from 'react'
import { downloadRecording } from 'utils/funcs/call-logs/downloadRecording'

export default function DownloadButton({ c_id }) {
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = useCallback(async () => {
    setIsDownloading(true)
    await downloadRecording(c_id)
    setIsDownloading(false)
  }, [c_id])

  return (
    <Button isLoading={isDownloading} variant="light" size="sm" radius="sm" color="secondary" isIconOnly onPress={handleDownload}>
      <Download size={14} />
    </Button>
  )
}
